<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">Informe os parâmetros para a criação da tabela de destino</div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <select-company :type="'outlined'" :selectedCompany="userLoggedCompany" @companySelected="companySelected" />
      </v-col>
    </v-row>
    <v-row v-if="companyId" class="mx-auto">
      <v-col cols="12">
        <select-schema :type="'outlined'" :companyId="companyId" @schemaSelected="schemaSelected" />
      </v-col>
    </v-row>
    <v-row v-if="loadingDadosTabela" class="mx-auto">
      <v-col cols="12" class="text-center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="mt-4">Carregando dados da tabela destino...</div>
      </v-col>
    </v-row>
    <v-row v-if="files && schemaDestino && layers.length" class="mx-auto">
      <v-col cols="12">
        <template v-if="layers.length > 1">
          <h3 class="mb-2">Layers:</h3>
          <v-tabs
            v-model="activeTab"
            background-color="transparent"
            color="primary"
            grow
            show-arrows
            icons-and-text
            class="overflow-x-auto"
            slider-color="primary"
            scrollable
          >
            <v-tab v-for="(layer, index) in layers" :key="layer.layer_name" :href="`#tab-${index}`">
              {{ layer.layer_name }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item v-for="(layer, index) in layers" :key="layer.layer_name" :value="`tab-${index}`">
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-text-field
                          v-model="layer.nome_tabela_destino"
                          label="Nome da Tabela Destino"
                          outlined
                          :error-messages="errors"
                          maxlength="50"
                          hint="Apenas letras minúsculas, números e underline ( _ ) são permitidos. (max 50 caracteres)"
                          @keypress="validarCaractere"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="pesquisaColuna"
                        label="Pesquisar coluna"
                        clearable
                        prepend-inner-icon="mdi-magnify"
                        hint="Pesquise pelo nome original da coluna"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Nome da Coluna</th>
                              <th class="text-left">Tipo da Coluna</th>
                              <th class="text-left">Dado de Exemplo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(coluna, i) in colunasFiltradas(layer)" :key="i">
                              <td>
                                <validation-provider v-slot="{ errors }" rules="required">
                                  <v-text-field
                                    v-model="layer.colunas_tabela_destino[indiceOriginal(coluna, layer)].nome_destino"
                                    :label="coluna"
                                    outlined
                                    :error-messages="errors"
                                    maxlength="100"
                                  />
                                </validation-provider>
                              </td>
                              <td>
                                <v-select
                                  v-model="layer.colunas_tabela_destino[indiceOriginal(coluna, layer)].tipo_coluna"
                                  label="Tipo da Coluna"
                                  :items="['varchar', 'text', 'integer', 'numeric', 'date', 'datetime']"
                                  outlined
                                  class="mb-0 pb-0"
                                  no-data-text="Nenhum tipo válido encontrado"
                                />
                              </td>
                              <td>{{ primeiraLinhaLayer(layer.layer_name)[coluna] }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </template>

        <template v-else>
          <div v-for="layer in layers" :key="layer.layer_name" class="mb-6">
            <v-row>
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="layer.nome_tabela_destino"
                    :label="'Nome da Tabela Destino'"
                    outlined
                    :error-messages="errors"
                    maxlength="50"
                    hint="Apenas letras minúsculas, números e underline ( _ ) são permitidos. (max 50 caracteres)"
                    @keypress="validarCaractere"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="pesquisaColuna"
                  label="Pesquisar coluna"
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  hint="Pesquise pelo nome original da coluna"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Nome da Coluna</th>
                        <th class="text-left">Tipo da Coluna</th>
                        <th class="text-left">Dado de Exemplo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(coluna, i) in colunasFiltradas(layer)" :key="i">
                        <td>
                          <validation-provider v-slot="{ errors }" rules="required">
                            <v-text-field
                              v-model="layer.colunas_tabela_destino[indiceOriginal(coluna, layer)].nome_destino"
                              :label="coluna"
                              outlined
                              :error-messages="errors"
                              maxlength="100"
                            />
                          </validation-provider>
                        </td>
                        <td>
                          <v-select
                            v-model="layer.colunas_tabela_destino[indiceOriginal(coluna, layer)].tipo_coluna"
                            label="Tipo da Coluna"
                            :items="['varchar', 'text', 'integer', 'numeric', 'date', 'datetime']"
                            outlined
                            class="mb-0 pb-0"
                            no-data-text="Nenhum tipo válido encontrado"
                          />
                        </td>
                        <td>{{ primeiraLinhaLayer(layer.layer_name)[coluna] }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CargasDadosGeograficosService from '@/services/CargasDadosGeograficosService';
  import SelectCompany from '@/components/general/SelectCompany.vue';
  import SelectSchema from '@/components/general/SelectSchema.vue';

  export default {
    name: 'SecondTabContent',
    components: {
      SelectCompany,
      SelectSchema
    },
    props: {
      files: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        dadosTabelaDestino: null,
        schemaDestino: null,
        layers: [],
        companyId: null,
        pesquisaColuna: '',
        activeTab: null,
        loadingDadosTabela: false
      };
    },
    computed: {
      userLoggedCompany() {
        return this.$store.getters.getSelectedCompany;
      }
    },
    mounted() {
      this.getDadosTabelaDestino();
    },
    methods: {
      companySelected(company) {
        this.companyId = company.id;
      },
      schemaSelected(schemaSelected) {
        this.schemaDestino = schemaSelected;
      },
      emitEventImportUpdated() {
        this.$emit('import:updated', {
          schemaDestino: this.schemaDestino,
          layers: this.layers,
          companyId: this.companyId
        });
      },
      getDadosTabelaDestino() {
        if (!this.files?.length) return;

        const arquivo = this.getArquivoPrincipal();
        if (!arquivo) return;

        this.loadingDadosTabela = true;

        const shp = this.files.find((a) => a.extensao?.toLowerCase() === 'shp');
        const extensaoSugerida = shp ? shp.extensao : null;

        CargasDadosGeograficosService.getDadosTabelaDestino(arquivo.id, extensaoSugerida)
          .then(({ data }) => {
            this.layers = Object.entries(data.layers).map(([layerName, layerData]) => ({
              layer_name: layerName,
              nome_tabela_destino: layerData.nome_tabela,
              colunas_tabela_destino: layerData.colunas.map((col) => ({
                nome_original: col,
                nome_destino: col,
                tipo_coluna: 'varchar'
              }))
            }));
            this.dadosTabelaDestino = data; // Para primeira_linha
            this.loadingDadosTabela = false;
          })
          .catch((error) => {
            this.loadingDadosTabela = false;
            console.error('Erro ao buscar dados da tabela destino:', error);
          });
      },

      getArquivoPrincipal() {
        const prioridade = ['dbf', 'json', 'kml', 'kmz', 'gdb'];

        for (const ext of prioridade) {
          const arquivo = this.files.find((a) => a.extensao?.toLowerCase() === ext);
          if (arquivo) return arquivo;
        }

        return null;
      },
      validarCaractere(event) {
        const char = event.key;
        if (!/^[a-z0-9_]$/.test(char)) {
          event.preventDefault();
        }
      },
      indiceOriginal(cabecalho, layer) {
        return layer.colunas_tabela_destino.findIndex((col) => col.nome_original === cabecalho);
      },
      colunasFiltradas(layer) {
        const cabecalhos = layer.colunas_tabela_destino.map((col) => col.nome_original);
        if (!this.pesquisaColuna) return cabecalhos;
        const pesquisa = this.pesquisaColuna.toLowerCase();
        return cabecalhos.filter((coluna) => coluna.toLowerCase().includes(pesquisa));
      },
      primeiraLinhaLayer(layerName) {
        return this.dadosTabelaDestino?.primeira_linha?.[layerName] || {};
      }
    },
    watch: {
      schemaDestino() {
        this.emitEventImportUpdated();
      },
      layers: {
        handler() {
          this.emitEventImportUpdated();
        },
        deep: true
      },
      companyId() {
        this.emitEventImportUpdated();
      },
      files() {
        this.getDadosTabelaDestino();
      }
    }
  };
</script>
